<template>
  <div id="page_report" :class="isDark==1?'page_report dark':'page_report'">
    <div v-show="backShow" class="report_nav">
      <img
        v-if="isDark==1"
        class="report_nav_img"
        src="../../assets/back_black.png"
        alt=""
        @click="back"
      />
      <img v-else class="report_nav_img" src="../../assets/back.png" alt="" @click="back" />
    </div>
    <div class="report_head">
      <img src="./head.png" alt="">
      <div>
        <h3>{{ $t('report.name1') }}</h3>
        <p>{{ $t('report.name2') }}</p>
      </div>
    </div>
    <div class="report_body">
      <div v-if="checkType.indexOf('1')>-1" class="item">
        <div class="title">
          <img src="./icon1.png" alt="">
          <span>{{capitalizeEachWord($t('report.name4').split(":")[1])}}</span>
        </div>
        <ul class="detail">
          <li class="date"><span>{{ $t('report.name3') }}</span><i>{{ initday(checkTime[0]) }}</i></li>
          <li class="method"><span>{{ $t('report.name4').split(":")[0]+":" }}</span><i>{{ $t('report.name4').split(":")[1] }}</i></li>
          <li class="img" v-if="imageUrl"><img :src="imageUrl" alt=""></li>
          <li class="scope"><span>{{ $t('report.name7').split(":")[0]+":" }}</span><i>{{ $t('report.name7').split(":")[1] }}</i></li>
          <li class="tags">
            <span class="lh24">{{ $t('report.name8') }}</span>
            <i class="tag">
              <span v-show="tags.indexOf('1')>-1">{{ $t('report.name9') }}</span>
              <span v-show="tags.indexOf('2')>-1">{{ $t('report.name10') }}</span>
              <span v-show="tags.indexOf('3')>-1">{{ $t('report.name11') }}</span>
            </i>
          </li>
        </ul>
      </div>
      <div v-if="checkType.indexOf('2')>-1" class="item">
        <div class="title">
          <img src="./icon2.png" alt="">
          <span>{{capitalizeEachWord($t('report.name5').split(":")[1])}}</span>
        </div>
        <ul class="detail">
          <li class="date"><span>{{ $t('report.name3') }}</span><i>{{ initday(checkTime[1]) }}</i></li>
          <li class="method"><span>{{ $t('report.name5').split(":")[0]+":" }}</span><i>{{ $t('report.name5').split(":")[1] }}</i></li>
          <li class="scope"><span>{{ $t('report.name6').split(":")[0]+":" }}</span><i>{{ $t('report.name6').split(":")[1] }}</i></li>
          <li class="tags">
            <span class="lh24">{{ $t('report.name8') }}</span>
            <i class="tag">
              <span v-show="tags.indexOf('4')>-1">{{ $t('report.name11') }}</span>
              <!-- 12，13在一起 -->
              <span v-show="tags.indexOf('5')>-1">{{ $t('report.name12') }}</span>
              <span v-show="tags.indexOf('5')>-1">{{ $t('report.name13') }}</span>
            </i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { setlang } from '../../i18n';
export default {
  name: "Report",
  data() {
    return {
      backShow:false,
      checkTime:[],//检测时间 
      imageUrl:'',
      checkType:'',// 检测类型 1 人工检测 2 自动检测
      isDark: '', //展示模式 0 正常 1 暗黑
      tags:'',//标签 人工123 自动45
    };
  },
  mounted() {
    let urlParm = this._parseQueryString("?" + (window.location.href.split("?")[1]||""));
    this.initlang(urlParm.language||'');
    this.imageUrl=urlParm.imageUrl||'';//'https://gips0.baidu.com/it/u=4139144156,1245604753&fm=3028&app=3028&size=r16,9&q=75&n=0&g=12n&f=PNG&fmt=auto&maxorilen2heic=2000000';
    this.checkType=(urlParm.checkType||'');
    this.checkTime=(urlParm.checkTime||"").split(',');
    this.isDark=urlParm.isDark||'';
    this.tags=urlParm.tags||'';
    if (window.android && window.android.finishWebActivity) {
      this.backShow=true;
    }else{
      this.backShow=false;
    }
  },
  methods: {
    //url解析入参
    _parseQueryString(queryString) {
      if(queryString=="?"){
        return {}
      }else if (queryString && queryString.startsWith("?")) {
        const result = {};
        queryString
          .slice(1)
          .split("&")
          .forEach((item) => {
            const keyValueList = item.split("=");
            result[keyValueList[0]] = decodeURIComponent(keyValueList[1]);
          });
        return result;
      } else {
        return {};
      }
    },
    // 初始化多语言
    initlang(lang){
      if(lang.toLowerCase()=='in'){
        lang='id';
      }
       //语言正反向
      if (['ar', 'ur'].indexOf(lang.split("-")[0].toLowerCase()) > -1) {
        document.getElementById("page_report").style.direction = "rtl";
        document.getElementsByClassName("report_nav_img")[0].style.transform="rotate(180deg)";
      } else {
        document.getElementById("page_report").style.direction = "ltr";
        document.getElementsByClassName("report_nav_img")[0].style.transform="rotate(0deg)";
      }
      this.$i18n.locale = setlang(lang);
    },
    // 首字母大写优化
    capitalizeEachWord(text) {
      if (!text) return ''; // 检查是否为空字符串
      return text
        .split(' ') // 按空格分割成单词数组
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // 每个单词首字母大写
        .join(' '); // 再拼接成一个字符串
    },
    // 日期处理
    initday(time){
      if(time&&time.length==13){
        return (new Date(+time).toISOString().split("T")[0])
      }else{
        return (new Date().toISOString().split("T")[0])
      }
    },
    // 返回
    back() {
      if (window.android && window.android.finishWebActivity) {
        window.android.finishWebActivity();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page_report{
  *{
    margin: 0;
    padding: 0;
  }
  li{
    list-style: none;
  }
  font-family: Roboto;
  font-weight: 500;
  letter-spacing: 0vw;
  vertical-align: middle;
  height: 100vh;
  overflow: auto;
  width: 100%;
  background: #fff;
  padding-top: 15.555556vw;
  padding-bottom: 11.38888vw;
  padding-bottom: 10vw;
  .report_nav{
    position: fixed;
    top: 0;
    left: 0;
    height: 10.6vw;
    background: #fff;
    width: 87.8vw;
    padding: 4.4vw 6.1vw 0;
    font-size: 0;
    img{
      width: 6.66667vw;
      height: auto;
    }
  }
  .report_head{
    text-align: center;
    line-height: 0;
    img{
      width: 66.66667vw;
      height: 46.388889vw;
    }
    div{
      width: 66.66667vw;
      margin: 0 auto;
      h3{
        font-size: 6.66667vw;
        line-height: 6.66667vw;
        text-align: center;
        font-weight: 500;
      }
      p{
        margin-top: 2.5vw;
        margin-bottom:6.94444vw;
        font-weight: 400;
        font-size: 3.88889vw;
        line-height: 4.72222vw;
        text-align: center;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
  .report_body{
    padding: 0 4.44444vw;
    .title{
      display: flex;
      align-items: center;
      font-size: 5vw;
      line-height: 6.11111vw;
      img{
        width: 6.11111vw;
        height: 6.11111vw;
        margin-inline-end: 1.66667vw;
      }
      margin-bottom: 2.77778vw;
    }
    .detail{
      margin-bottom: 4.1666667vw;
      li{
        margin-bottom: 1.666667vw;
        line-height: 4.44444vw;
        font-size: 3.33333vw;
        color: rgba(0, 0, 0, 0.7);
        display: flex;
        span{
          font-size: 3.888889vw;
          margin-inline-end: 1.666667vw;
        }
        i{
          font-style: normal;
          font-size: 3.6111vw;
          color: rgba(0, 0, 0, 0.65);
          font-weight: normal;
        }
        .tag{
          span{
            margin-inline-end: 2.22222vw;
            display: inline-block;
            font-weight: 400;
            font-size: 3.333333vw;
            line-height: 6.666667vw;
            text-align: center;
            background: rgba(0, 122, 255, 0.12);
            padding: 0 2.22222vw;
            margin-bottom: 1.66667vw;
            border-radius: 1.11111vw;
            color: #007EFF;
          }
        }
        .lh24{
          line-height: 6.666667vw;
        }
      }
      .img{
        text-align: center;
        margin-top: 2.777778vw;
        margin-bottom: 2.7777778vw;
        img{
          width: 66.666667vw;
          margin: 0 auto;
          border-radius: 2.777778vw;
        }
      }
      .date{
        i{
          position: relative;
          top:0.3333333vw;
        }
      }
      .tags{
        margin-top: 2.788888vw;
      }
    }
  }
}

// Pad 端使用固定的内容尺度，避免继续按视口宽度放大手机端布局。
@media (min-width: 768px) {
  .page_report {
    box-sizing: border-box;
    width: 100%;
    max-width: none;
    min-height: 100vh;
    margin: 0 auto;
    padding-top: 64px;
    padding-bottom: 56px;

    .report_nav {
      box-sizing: border-box;
      left: 50%;
      width: 100%;
      max-width: none;
      height: 64px;
      padding: 20px 32px 16px;
      transform: translateX(-50%);

      img {
        width: 28px;
      }
    }

    .report_head {
      img {
        width: 480px;
        max-width: calc(100% - 64px);
        height: auto;
      }

      div {
        width: 480px;
        max-width: calc(100% - 64px);

        h3 {
          font-size: 32px;
          line-height: 40px;
        }

        p {
          margin-top: 12px;
          margin-bottom: 32px;
          font-size: 18px;
          line-height: 26px;
        }
      }
    }

    .report_body {
      box-sizing: border-box;
      width: calc(100% - 64px);
      max-width: 960px;
      margin: 0 auto;
      padding: 0;

      .title {
        margin-bottom: 16px;
        font-size: 24px;
        line-height: 32px;

        img {
          width: 28px;
          height: 28px;
          margin-inline-end: 8px;
        }
      }

      .detail {
        margin-bottom: 24px;

        li {
          margin-bottom: 8px;
          line-height: 24px;
          font-size: 16px;

          span {
            margin-inline-end: 8px;
            font-size: 18px;
          }

          i {
            font-size: 16px;
          }

          .tag {
            span {
              margin-inline-end: 8px;
              margin-bottom: 8px;
              padding: 0 10px;
              border-radius: 6px;
              font-size: 14px;
              line-height: 32px;
            }
          }
        }

        .img {
          margin-top: 16px;
          margin-bottom: 16px;

          img {
            width: 480px;
            max-width: 100%;
            border-radius: 12px;
          }
        }

        .date {
          i {
            top: 2px;
          }
        }

        .tags {
          margin-top: 14px;
          align-items: flex-start;

          > .lh24 {
            display: block;
            flex: 0 0 auto;
            line-height: 32px;
          }

          .tag {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 8px;

            span {
              margin: 0;
            }
          }
        }

        .lh24 {
          line-height: 32px;
        }
      }
    }
  }
}

// 横屏 Pad 使用视口宽度排版，并收紧纵向空间，避免出现两侧空白和内容需要滚动才能看完。
@media (min-width: 768px) and (orientation: landscape) {
  .page_report {
    max-width: none;
    width: 100%;
    padding-top: 48px;
    padding-bottom: 24px;

    .report_nav {
      max-width: none;
      height: 48px;
      padding: 14px 32px 10px;
    }

    .report_head {
      img {
        width: 360px;
      }

      div {
        width: 640px;
        max-width: calc(100% - 64px);

        h3 {
          font-size: 28px;
          line-height: 34px;
        }

        p {
          margin-top: 8px;
          margin-bottom: 20px;
          font-size: 16px;
          line-height: 22px;
        }
      }
    }

    .report_body {
      width: calc(100% - 64px);
      max-width: 960px;

      .detail {
        .img {
          img {
            width: 360px;
          }
        }
      }
    }
  }
}

.dark{
  background: #000;
  color: #fff;
  .report_nav{
    background: #000;
  }
  .report_head{
    div p{
      color: rgba(255, 255, 255, 0.65);
    }
  }
  .report_body{
    .detail li{
      color: rgba(222, 222, 222, 0.8);
      .tag span{
        background: rgba(0, 122, 255, 0.21);
      }
      i{
        color: rgba(222, 222, 222, 0.7);
        font-weight: normal;
      }
    }
  }
}
</style>
